import base from './base.repository';
import base2 from './base2.repository';
export default {
    ...base,
    get: (filters) => {
        return base2.get('structures', filters)
    },
    getPaginated(clientId, page, filters){
        const params = {...filters, page, client: clientId};
        return base2.get(`structures`, params);
    },
    async all(clientId){
        const {data} = await base2.get(`structures?client=${clientId}`);
        return data;
    },
    async byId(id){
        const {data} = await base2.get(`structures/${id}`);
        return data;
    },
    async getStructureTypes(){
        const {data} = await base2.get('structure-types');
        return data;
    },
    async byType(StructureTypeId,clientId){
        const {data} = await base2.get(`structures/type/${StructureTypeId}?client=${clientId}`);
        return data;
    },
    async accessPointsByClient(clientId){
        const {data} = await base2.get(`structures/access-points/client/${clientId}`);
        return data;
    },
    saveStructure(structure) {
        this.post(`structures`, structure);
        return this;
    },
    deleteStructure(id){
        this.delete('structures/'+ id);
        return this;
    },
}